import { Fragment, ReactNode } from 'react';

function flattenChildren(nodes: ReactNode | ReactNode[]): ReactNode[] {
    const parts = Array.isArray(nodes) ? nodes : [nodes];
    return parts.flat(Infinity) as ReactNode[];
}

export function TranslateSafeText({ children }: { children: ReactNode | ReactNode[] }) {
    const parts = flattenChildren(children);
    return (
        <>
            {parts.map((part, index) => {
                if (typeof part === 'string' || typeof part === 'number') {
                    return <span key={index}>{part}</span>;
                }
                return <Fragment key={index}>{part}</Fragment>;
            })}
        </>
    );
}

export default TranslateSafeText;
